import { useState } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import {
  TableRow,
  TableCell,
  MenuItem,
  Tooltip,
  Avatar,
  Box,
  Stack,
  Typography,
} from '@mui/material';
// @types

// components
import useLocales from 'src/hooks/useLocales';
import PermissionBasedGuard from 'src/guards/PermissionBasedGuard';
import { ICustomer } from 'src/@types/Choqorak/MainTables/Contract/Customer';
import { TableMoreMenu } from 'src/components/table';
import Iconify from 'src/components/Iconify';
import { baseUrl } from 'src/api/baseUrl';

// ----------------------------------------------------------------------

const language = window.localStorage.getItem('i18nextLng');

type Props = {
  row: ICustomer;
  index: any;
  onEditRow: VoidFunction;
  onCreateUser: VoidFunction;
  onDeleteRow: VoidFunction;
  handleDetail: VoidFunction;
  doubleClick: any;
};

export default function CustomerTableRow({
  row,
  onEditRow,
  onCreateUser,
  onDeleteRow,
  handleDetail,
  index,
  doubleClick,
}: Props) {
  const theme = useTheme();
  const language = window.localStorage.getItem('i18nextLng');
  const {
    customerId: id,
    surName,
    profilePhoto,
    customerFatherName,
    customerName,
    phoneNumber,
    name,
    branchName,
    personalEmail,
    photoPath,
  } = row;
  const { translate } = useLocales();
  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };
  let Url = baseUrl;
 
  return (
    <Tooltip
      title={
        <span>
          {translate('Customer.DoubleClick')}{' '}
          <span style={{ color: '#00bcd4', fontSize: '13px', fontWeight: 'bold' }}>
            {customerName}
          </span>{' '}
          {translate('Customer.CustomerDetail')}
        </span>
      }
      placement="top"
    >
      <TableRow hover onClick={doubleClick}>
        <TableCell align="left">{index + 1}</TableCell>
        <TableCell align="left">
          {
            <TableCell>
              <Stack direction="row" alignItems="center">
                <Avatar alt={name} src={Url + photoPath} />

                <Box sx={{ ml: 2 }}>
                  <Typography variant="subtitle2"> {row.name} </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {customerName}
                  </Typography>
                </Box>
              </Stack>
            </TableCell>
          }
        </TableCell>

      

        {/* <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
          {branchName}
        </TableCell> */}

        <TableCell
          align="left"
          sx={{ textTransform: 'capitalize', alignItems: 'left' }}
          dir={language === 'en' ? 'ltr' : 'ltr'}
        >
          {customerFatherName}
        </TableCell>
         <TableCell
          align="left"
          sx={{ textTransform: 'capitalize', alignItems: 'left' }}
          dir={language === 'en' ? 'ltr' : 'ltr'}
        >
          {personalEmail}
        </TableCell>
        <TableCell
          align="left"
          sx={{ textTransform: 'capitalize', alignItems: 'left' }}
          dir={language === 'en' ? 'ltr' : 'ltr'}
        >
          {phoneNumber}
        </TableCell>
        <TableCell align="left">
          <TableMoreMenu
            open={openMenu}
            onOpen={handleOpenMenu}
            onClose={handleCloseMenu}
            actions={
              <>
                <PermissionBasedGuard permissions={['Customer-Delete']}>
                  <MenuItem
                    onClick={() => {
                      onDeleteRow();
                      handleCloseMenu();
                    }}
                    sx={{ color: 'error.main' }}
                  >
                    <Iconify icon={'eva:trash-2-outline'} />
                    {translate('CRUD.Delete')}
                  </MenuItem>
                </PermissionBasedGuard>
                <PermissionBasedGuard permissions={['Customer-Update']}>
                  <MenuItem
                    onClick={() => {
                      onEditRow();
                      handleCloseMenu();
                    }}
                  >
                    <Iconify sx={{ color: 'warning.main' }} icon={'eva:edit-fill'} />
                    {translate('CRUD.Update')}
                  </MenuItem>
                </PermissionBasedGuard>

                <PermissionBasedGuard permissions={['Customer-GetDetail']}>
                  <MenuItem
                    onClick={() => {
                      handleDetail();
                      handleCloseMenu();
                    }}
                  >
                    <Iconify sx={{ color: 'info.main' }} icon={'mdi:account-details'} />
                    {translate('CRUD.Detail')}
                  </MenuItem>
                </PermissionBasedGuard>
              </>
            }
          />
        </TableCell>
      </TableRow>
    </Tooltip>
  );
}
